// Copyright ©️ 2026 eVolve MEP, LLC

import type { Shipment } from '@evolvemep/api-ts';

import { FormModal } from 'components/Mantine/Modals/FormModal';
import { AddShipmentItemsForm } from 'modules/Shop/Shipments/ShipmentDetail/AddShipmentItemsModal/AddShipmentItemsForm';

type Props = {
  shipment: Shipment;
  opened: boolean;
  onClose: () => void;
  onItemsAdded: () => void;
};

export const AddShipmentItemsModal = ({ shipment, opened, onClose, onItemsAdded }: Props) => (
  <FormModal
    title="Add work items"
    opened={opened}
    onClose={onClose}
    type="submit"
    confirmationText="Add items"
    tall
    size={1125}
    miniHeader={`${shipment.identifier}: ${shipment.name}`}
    startDirty
  >
    <AddShipmentItemsForm shipment={shipment} onItemsAdded={onItemsAdded} />
  </FormModal>
);
